'use client';

/**
 * @packageDocumentation
 * @category Page
 */

import { Button, Fallback } from '@bomdisoft/components';
import { getLanguageCode, SupportedLanguage, somethingWentWrongT, tryAgain } from '@bomdisoft/translations';
import s from '@pieleaf/app/styles.module.css';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

const GlobalError = ({ reset, error }: { error: Error & { digest?: string }; reset: () => void }) => {
  const language: SupportedLanguage = 'english';

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang={getLanguageCode(language)}>
      <body>
        <div className={s.errorBox}>
          <Fallback message={somethingWentWrongT[language]} />
          <Button color='info' onClick={() => reset()} variant='contained'>
            {tryAgain[language]}
          </Button>
        </div>
      </body>
    </html>
  );
};

export default GlobalError;
